import React, { useState } from "react";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDSnackbar from "components/MDSnackbar";
import { 
  Table, TableBody, TableCell, TableContainer, 
  TableHead, TableRow, Card, CircularProgress, Divider 
} from "@mui/material";
import axios from "axios";

function SearchStudent() {
  const [mobile, setMobile] = useState("");
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const closeSuccessSB = () => setSuccessSB(false);
  const closeErrorSB = () => setErrorSB(false);

  // Clear Function
  const handleClear = () => {
    setMobile("");
    setStudents([]);
    setHasSearched(false);
  };

  const handleSearch = async () => {
    if (!mobile || mobile.length < 10) {
      setErrorMessage("Please enter a valid 10-digit mobile number");
      setErrorSB(true);
      return;
    }

    setLoading(true);
    setHasSearched(true);
    try {
      const response = await axios.get(`https://v3.dhundhoo.com/getStudents/${mobile}`);
      setStudents(response.data);
      if (response.data.length > 0) {
        setSuccessSB(true);
      }
    } catch (error) {
      setErrorMessage("Failed to fetch student details.");
      setErrorSB(true);
      setStudents([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MDBox py={3}>
      <MDBox display="flex" justifyContent="center" mb={4}>
        <Card sx={{ width: "100%", maxWidth: "800px", p: 3, boxShadow: 3 }}>
          <MDTypography variant="h6" fontWeight="medium" mb={2}>
            Student Quick Search
          </MDTypography>
          
          <MDBox display="flex" alignItems="center" gap={1.5}>
            <MDInput
              label="Mobile Number"
              placeholder="e.g. 9876543210"
              variant="outlined"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              type="number"
              fullWidth
            />
            
            {/* Search Button */}
            <MDButton 
              variant="gradient" 
              color="info" 
              onClick={handleSearch} 
              disabled={loading}
              sx={{ minWidth: "110px" }}
            >
              {loading ? <CircularProgress size={20} color="inherit" /> : "SEARCH"}
            </MDButton>

            {/* Clear Button */}
            <MDButton 
              variant="outlined" 
              color="secondary" 
              onClick={handleClear}
              disabled={loading || (!mobile && students.length === 0)}
              sx={{ minWidth: "100px" }}
            >
              CLEAR
            </MDButton>
          </MDBox>
        </Card>
      </MDBox>

      <MDBox mt={4}>
        <Card>
          <MDBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
            <MDTypography variant="h6">Search Results</MDTypography>
            {students.length > 0 && (
               <MDTypography variant="button" color="text" fontWeight="regular">
                 Found {students.length} record(s)
               </MDTypography>
            )}
          </MDBox>
          <Divider sx={{ my: 0 }} />
          
          {students.length > 0 ? (
            <TableContainer sx={{ boxShadow: "none" }}>
              <Table>
                <TableHead sx={{ display: "table-header-group", backgroundColor: "#f8f9fa" }}>
                  <TableRow>
                    <TableCell><MDTypography variant="button" fontWeight="bold" color="secondary" opacity={0.7}>FIRST NAME</MDTypography></TableCell>
                    <TableCell><MDTypography variant="button" fontWeight="bold" color="secondary" opacity={0.7}>LAST NAME</MDTypography></TableCell>
                    <TableCell><MDTypography variant="button" fontWeight="bold" color="secondary" opacity={0.7}>ROLL NO</MDTypography></TableCell>
                    <TableCell><MDTypography variant="button" fontWeight="bold" color="secondary" opacity={0.7}>ORGANIZATION</MDTypography></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {students.map((student, index) => (
                    <TableRow key={index} sx={{ "&:hover": { backgroundColor: "#fafafa" } }}>
                      <TableCell><MDTypography variant="caption" fontWeight="medium">{student.firstName || "-"}</MDTypography></TableCell>
                      <TableCell><MDTypography variant="caption" fontWeight="medium">{student.lastName || "-"}</MDTypography></TableCell>
                      <TableCell>
                        <MDBox sx={{ px: 1.5, py: 0.5, borderRadius: "6px", backgroundColor: "#f0f2f5", display: "inline-block", border: "1px solid #dee2e6" }}>
                           <MDTypography variant="caption" fontWeight="bold" color="dark">{student.rollNo}</MDTypography>
                        </MDBox>
                      </TableCell>
                      <TableCell><MDTypography variant="caption" color="text">{student.orgName}</MDTypography></TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <MDBox p={5} textAlign="center">
              <MDTypography variant="body2" color="text" opacity={0.6}>
                {hasSearched ? "No data found for this number." : "Results will appear here after search."}
              </MDTypography>
            </MDBox>
          )}
        </Card>
      </MDBox>

      {/* Snackbars */}
      <MDSnackbar color="success" icon="check" title="Success" content="Data fetched successfully!" open={successSB} onClose={closeSuccessSB} close={closeSuccessSB} />
      <MDSnackbar color="error" icon="warning" title="Error" content={errorMessage} open={errorSB} onClose={closeErrorSB} close={closeErrorSB} />
    </MDBox>
  );
}

export default SearchStudent;